import { Seo } from '../seo/Seo';
import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';

const AdminApp = () => {
  const [adminInfo, setAdminInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin is already logged in
    const token = localStorage.getItem('adminToken');
    const storedAdminInfo = localStorage.getItem('adminInfo');
    
    if (token && storedAdminInfo) {
      try {
        setAdminInfo(JSON.parse(storedAdminInfo));
      } catch (error) {
        console.error('Error parsing admin info:', error);
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminInfo');
      }
    }
    
    setLoading(false);
  }, []);

  const handleLoginSuccess = (info) => {
    setAdminInfo(info);
  };

  const handleLogout = () => {
    setAdminInfo(null);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminInfo');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading admin panel...</p>
        </div>
      </div>
    );
  }

  const seo = <Seo path="/admin" noindex title="FlameLink Admin" description="Administrator sign-in." />;
  if (!adminInfo) {
    return <>{seo}<AdminLogin onLoginSuccess={handleLoginSuccess} /></>;
  }

  return <>{seo}<AdminDashboard adminInfo={adminInfo} onLogout={handleLogout} /></>;
};

export default AdminApp;